import { render, staticRenderFns } from "./UiMenuMobile.vue?vue&type=template&id=24464f26&scoped=true&"
import script from "./UiMenuMobile.vue?vue&type=script&lang=js&"
export * from "./UiMenuMobile.vue?vue&type=script&lang=js&"
import style0 from "./UiMenuMobile.vue?vue&type=style&index=0&id=24464f26&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24464f26",
  null
  
)

export default component.exports